// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_zbS","cls2":"Comments-cls2_OpS Comments-cls1_zbS"};